import React from "react";
import { Col, Row } from "react-bootstrap";
import logoIcon from "@frameworks/shared-library/assets/images/generic/nuvama_logo.png";
var ProfileCard = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: " d-flex justify-content-center text-center mgt-9-61" },
                React.createElement("div", { className: "ProfileCard-box" },
                    React.createElement("div", null,
                        React.createElement("p", { className: "d-flex justify-content-center" },
                            React.createElement("img", { src: logoIcon })),
                        React.createElement("span", { className: "DMSanN_16_400 txt-midnight-blue d-flex justify-content-center mt-3" }, props.name),
                        React.createElement("span", { className: "DMSansNormal_12_400 txt-midnight-blue d-flex justify-content-center" }, props.destination)),
                    React.createElement("div", { className: "middle-space" },
                        React.createElement("span", { className: "Roboto_12_400 txt-midnight-blue d-flex justify-content-center" }, props.phoneNo),
                        React.createElement("span", { className: "Roboto_12_400 txt-midnight-blue d-flex justify-content-center mt-2" }, props.email),
                        React.createElement("span", { className: "icon-section DMSan_20_700 mt-2 px-5 txt-midnight-blue" },
                            React.createElement("i", { className: "edel-icon-linkedin" }),
                            React.createElement("i", { className: "edel-icon-facebook" }),
                            React.createElement("i", { className: "edel-icon-twitter txt_monochromeGrey" }))))))));
};
export default ProfileCard;
